import React from 'react';
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {FilterItemBox} from "./boxes/filter-Item.box";
import {InputBox} from "./boxes/input.box";
import {FilterItemTitleBox} from "./boxes/filter-item-title.box";
import {
    IArenaGameFilterEditorViewModel
} from "../../../../services/games-filter/arena-filters/filters/arena-game-filter-editor-view-model.interface";
import {observer} from "mobx-react";
import {SubFiltersBox} from "./boxes/sub-filters.box";
import {FilterItemContainerBox} from "./boxes/filter-item-container.box";
import {CyClass} from "../../../../../common/cy-classes";

export type FilterInputType = 'checkbox' | 'radio';

interface FilterCategoryItemComponentProps {
    inputType: FilterInputType;
    filter: IArenaGameFilterEditorViewModel;
    filterCategoryId: string;
}

export const FilterCategoryItemComponent = observer(
    class FilterCategoryItemComponent extends OrbitComponent<FilterCategoryItemComponentProps> {

        private _onFilterToggle = () => {
            if (this.props.filter.disabled) {
                return;
            }
            this.props.filter.toggleFilter();
        }

        private _renderSubFilters() {
            const subFilters = this.props.filter.subFilters;
            if(subFilters.length === 0) {
                return null;
            }

            return (
                <SubFiltersBox>
                    {subFilters.map(sf => (<FilterCategoryItemComponent key={sf.id}
                                                                        filterCategoryId={this.props.filterCategoryId}
                                                                        filter={sf}
                                                                        inputType="checkbox"/>))}
                </SubFiltersBox>
            )
        }

        render() {
            const filter = this.props.filter;
            const inputType = this.props.inputType;

            return (
                <FilterItemContainerBox disabled={filter.disabled} className={CyClass('cy-game-filter-item')}>
                    <FilterItemBox onClick={this._onFilterToggle} disabled={filter.disabled}>
                        <InputBox type={inputType} name={`${this.props.filterCategoryId}-option`} checked={Boolean(filter.on)} readOnly disabled={filter.disabled}/>
                        <FilterItemTitleBox isChecked={filter.on}>
                            {filter.text}
                            {filter.gamesCount > 0 && ` (${filter.gamesCount})`}
                        </FilterItemTitleBox>
                    </FilterItemBox>
                    {this._renderSubFilters()}
                </FilterItemContainerBox>

            );
        }
    }
);